export default {
    common: {
        default: "Document",
        kicker: "User Agreement",
        navTitle: "Documents",
        empty: "No document content",
        terms: "Terms of Service",
        termsDesc: "Service rules",
        privacy: "Privacy Policy",
        privacyDesc: "Data and privacy",
    },
};
